export default "__VITE_ASSET__DP1wVKLC__"